export default {
    IDLE: "IDLE",
    INSEMINATED: "INSEMINATED",
    NOT_IN_PRODUCTION: "NOT_IN_PRODUCTION",
    FARROWED: "FARROWED",
    SEPARATED: "SEPARATED",
    SOLD: "SOLD",
    DEAD: "DEAD",
};
